import { AppMapperError, Mapper } from 'module/Common';
import { MelezeConfig } from 'module/Model/MelezeConfig';
import { PreviewType, Route, RouteType } from 'module/Model/Routes';

export namespace MelezeConfigMapper {
  const routeMapper = (path: string) =>
    Mapper.mapSchema(
      {
        type: Mapper.stringEnum<RouteType>(RouteType),
        link: Mapper.str,
        id: Mapper.maybeUndefined(Mapper.stringInt, null),
      },
      v => {
        const route: Route = {
          type: v.type,
          link: v.link,
          id: v.id,
          path,
        };
        return route;
      }
    );

  export const map = Mapper.create<MelezeConfig>(
    Mapper.errorWrapper(
      err => new AppMapperError('SystemConfig', err),
      Mapper.mapSchema(
        {
          routes: Mapper.plainObjectAdvanced<string, Route>(Mapper.str, (val, key) => routeMapper(key)),
          config: Mapper.mapSchema(
            {
              posts_per_page: Mapper.stringInt,
              admin_bar: Mapper.bool,
            },
            v => {
              const adminBar = v.admin_bar; // process.env.NODE_ENV !== 'production' ? v.admin_bar : false;
              return {
                ...v,
                admin_bar: adminBar,
              };
            }
          ),
          preview: Mapper.nullable(
            Mapper.schema({
              id: Mapper.num,
              data: Mapper.anyNotUndefined,
              type: Mapper.stringEnum<PreviewType>(PreviewType),
            })
          ),
          pathname: Mapper.str,
          matching_route: Mapper.nullable(routeMapper('')),
          prefetch: Mapper.plainObject(Mapper.str, Mapper.anyNotUndefined),
        },
        v => v
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/module/Service/MelezeConfig/MelezeConfigMapper.ts